import { CelebrityTeams } from '../../collections';

/**
 * @desc CelebrityTeams
 */
export class TippingCelebrityTeams extends CelebrityTeams {
	set_show_my_url() {
		this.url = 'comps/celebrity_users';
		return this;
	}

	set_celebrity_teams_url() {
		this.url = 'comps/add_comp_celebrity_users';
		return this;
	}
}

export default TippingCelebrityTeams;